import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setListening, mute, unmute } from '../../redux/slices/aiSlice';
import { signedOut } from '../../redux/slices/authSlice';
import AIStatusIndicator from '../../components/ui/AIStatusIndicator';
import './styles.css';

export default function IaListening() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const ai = useSelector(s => s.ai || s.aiSlice) || {};
  const iaStatus = ai.status || 'loading';
  const muted = ai.muted || false;

  const onBack = () => {
    localStorage.clear();
    dispatch(signedOut());
    navigate('/app-sharma/Login', { replace: true });
  };

  const onPressMic = useCallback(() => {
    if (muted) {
      window.gptRealtimeControl?.continue?.();
      dispatch(unmute());
    } else {
      window.gptRealtimeControl?.stop?.();
      dispatch(mute());
    }
  }, [dispatch, muted]);

  return (
    <div className="ia-bg" style={{ backgroundImage: 'url(/assets/home.png)' }}>
      <div className="ia-top">
        <button className="ia-btn" aria-label="ghost" />
        <span className="ia-text-ryse-white">RYSE·</span>
        <button onClick={onBack} className="ia-exit" aria-label="salir">
          <img
            src="/assets/exit-home.png"
            alt="Salir"
            className="ia-exit-icon"
          />
        </button>
      </div>

      <div className="ia-center">
        <AIStatusIndicator
          status={iaStatus}
          muted={muted}
          onMicPress={onPressMic}
        />
      </div>
    </div>
  );
}
